import { EMoneyConditionType } from "../../Enum/EMoneyConditionType"
import { AwardEntity } from "../Awards/AwardEntity"

type AwardCandidate<T> = {
  source: T
  award: AwardEntity
}

type ApplyAwardDiscountOptions<T> = {
  candidates: AwardCandidate<T>[]
  initialTotal: number
}

export type AppliedAwardDiscount<T> = {
  source: T
  discount: number
}

export const ApplyAwardDiscounts = <T>({
  candidates,
  initialTotal,
}: ApplyAwardDiscountOptions<T>): AppliedAwardDiscount<T>[] => {
  let runningTotal = initialTotal

  const applied: AppliedAwardDiscount<T>[] = []

  const sortedCandidates = [...candidates].sort(
    (a, b) =>
      Number(b.award.conditionType === EMoneyConditionType.Percentage) -
      Number(a.award.conditionType === EMoneyConditionType.Percentage),
  )

  for (const candidate of sortedCandidates) {
    if (runningTotal <= 0) {
      break
    }

    let discount = candidate.award.getValue(runningTotal)

    discount = Math.min(discount, runningTotal)

    if (discount <= 0) {
      continue
    }

    runningTotal -= discount

    applied.push({ source: candidate.source, discount })
  }

  return applied
}
